import { render, staticRenderFns } from "./the-modal.vue?vue&type=template&id=089d9f88&scoped=true"
import script from "./the-modal.vue?vue&type=script&lang=js"
export * from "./the-modal.vue?vue&type=script&lang=js"
import style0 from "./the-modal.vue?vue&type=style&index=0&id=089d9f88&prod&lang=scss&scoped=true"
import style1 from "./the-modal.vue?vue&type=style&index=1&id=089d9f88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d9f88",
  null
  
)

export default component.exports